<template>
    <div class="titleBar" :class="{'titleBarDark' : isDark}">
        <span class="modleName"><em :class="{'icon': true, 'cold':type === '18', 'oddsWave':type === '17', 'full':type === '16', 'big':type === '15', 'poisson':type === '21', 'margin':type === '23', 'attitude':type === '5', 'ai':type === '6', 'android': isAndroid}"></em>{{title}}</span>
        <span class="details">{{txt}}</span>
        <span class="btn" @click="goModelList">查看更多<van-icon name="arrow" size="10" /></span>
    </div>
</template>

<script>
import { isJHApp, isAndroid, isJHApphm, getAppV } from "../../../utils/base";

import jsbridg from '../../../utils/jsbridg'
export default {
    name: 'titleBarCorpus',
    props: ['title', 'txt', 'type', 'modelIcon'],
    data () {
        return {}
    },
    computed: {
        isAndroid () {
            return isAndroid()
        },
        isDark () {
            return this.$store.state.common.isDark
        }
    },
    methods: {
        // 跳转模型列表页
        goModelList () {
            let modelListUrl = '';
            // margin模型
            if (this.type === "23") {
                modelListUrl = process.env.VUE_APP_CP_DOMAIN + 'cp/model/jihai/corpus/margin/list';
            } else if (this.type === "19") {
                modelListUrl = process.env.VUE_APP_DOMAIN + '/model/report';
            } else {
                // 其他模型
                if (process.env.NODE_ENV === "production") {
                    modelListUrl = process.env.VUE_APP_H5_DOMAIN + '/page/daily_list?type=' + this.type;
                } else {
                    modelListUrl = process.env.VUE_APP_H5_DOMAIN + '/page/daily_list?type=' + this.type;
                }
            }
            if (isJHApp()) {
                if (!isJHApphm() && getAppV() >= 464 && (this.type * 1 === 18 || this.type * 1 === 17 || this.type * 1 === 16 || this.type * 1 === 21 || this.type * 1 === 15 || this.type * 1 === 20)) {
                    const codeMap = {
                        15: 534,
                        16: 542,
                        17: 540,
                        18: 541,
                        21: 543,
                        20: 535
                    };
                    jsbridg.goWebview({
                        code: codeMap[this.type * 1],
                        jumptype: 1
                    });
                } else {
                    if (!isJHApphm() && getAppV() >= 441 && (this.type * 1 === 15 || this.type * 1 === 20)) {
                        jsbridg.goWebview({
                            code: this.type * 1 === 15 ? '534' : '535',
                            jumptype: 1
                        });
                    } else {
                        jsbridg.goWebview({
                            url: modelListUrl,
                            jumptype: 2
                        });
                    }
                }
            } else {
                window.open(modelListUrl);
            }
        }
    }
}
</script>

<style lang="less" scoped>
    .titleBar{
        position: relative;
        width: 100%;
        height: 35px;
        line-height: 35px;
        padding: 0 14px;
        background: #F5F5F5;
        overflow: hidden;
        span{
            display: inline-block;
            vertical-align: middle;
            &.modleName{
                position: relative;
                padding-left: 22px;
                font-size: 14px;
                font-weight: bold;
                color: #333333;
                .icon{
                    position: absolute;
                    top: 6px;
                    left: 0;
                    width: 22px;
                    height: 22px;
                    background-image: url('../../../assets/img/datamodel/information.png');
                    background-size: cover;
                    &.cold{
                        background-image: url('../../../assets/img/datamodel/cold.png');
                    }
                    &.ai{
                        background-image: url('../../../assets/img/datamodel/ai.png');
                    }
                    &.attitude{
                        background-image: url('../../../assets/img/datamodel/attitude.png');
                    }
                    &.big{
                        background-image: url('../../../assets/img/datamodel/big.png');
                    }
                    &.full{
                        background-image: url('../../../assets/img/datamodel/full.png');
                    }
                    &.margin{
                        background-image: url('../../../assets/img/datamodel/margin.png');
                    }
                    &.oddsWave{
                        background-image: url('../../../assets/img/datamodel/oddsWave.png');
                    }
                    &.poisson{
                        background-image: url('../../../assets/img/datamodel/poisson.png');
                    }
                    &.android{
                        top: 4.5px;
                    }
                }
            }
            &.details{
                font-size: 13px;
                color: #FF5048;
            }
            &.btn{
                float: right;
                font-size: 10px;
                color: #169AFF;
            }
        }
    }
    .titleBarDark {
        background: #191919;
        span {
            &.modleName{
                color: #d3d3d3;
            }
        }
    }
</style>
